import cloneDeep from "lodash.clonedeep";
import { actions } from "./actions";
import { DEFAULT_STATE } from "./state";
import { mutationTypes, getterTypes } from "./types";

export default {
    actions,
    mutations: {
        [mutationTypes.getConfigsStart](state) {
            state.isLoadingConfigs = true;
        },
        [mutationTypes.getConfigsSuccess](state, data) {
            state.isLoadingConfigs = false;
            state.configs = data.data;
            state.statsDays = data.stats_days;
            state.defaultChannel = data.default_channel;
        },
        [mutationTypes.getConfigsFailure](state) {
            state.isLoadingConfigs = false;
        },
        [mutationTypes.getSilencesStart](state) {
            state.isLoadingSilences = true;
        },
        [mutationTypes.getSilencesSuccess](state, data) {
            state.isLoadingSilences = false;
            state.silences = data.data;
        },
        [mutationTypes.getSilencesFailure](state) {
            state.isLoadingSilences = false;
        },
        [mutationTypes.getAlertsStart](state) {
            state.isLoadingAlerts = true;
        },
        [mutationTypes.getAlertsSuccess](state, data) {
            state.isLoadingAlerts = false;
            state.alerts = data.data;
        },
        [mutationTypes.getAlertsFailure](state) {
            state.isLoadingAlerts = false;
        },
    },
    getters: {
        [getterTypes.getConfigs]: (state) => state.configs,
        [getterTypes.getStatsDays]: (state) => state.statsDays,
        [getterTypes.getDefaultChannel]: (state) => state.defaultChannel,
        [getterTypes.getSilences]: (state) => state.silences,
        [getterTypes.getAlerts]: (state) => state.alerts,
        [getterTypes.isLoadingConfigs]: (state) => state.isLoadingConfigs,
        [getterTypes.isLoadingSilences]: (state) => state.isLoadingSilences,
        [getterTypes.isLoadingAlerts]: (state) => state.isLoadingAlerts,
    },
    state: cloneDeep(DEFAULT_STATE),
};
